import React, { Component } from 'react';
import { reduxForm, Field, change } from 'redux-form';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { CommonButton } from '../../../../../components/buttons';
import { getClientsForBehaviorDownload, getBehaviorsByClientIds, downloadBehaviorsForRawData } from './actions/downloadBehaviorsForRawDataAction';
import { renderAutoCompleteMultipleSelection, renderCheckBox } from '../../../../../components/reduxFields';
import Checkbox from 'material-ui/Checkbox';

class DownloadBehaviorsForRawDataModal extends Component {    constructor(props) {
        super(props);
        this.state = {
            open: true,
            clients: [],
            behaviors: [],
            loading: false,
            selectAllClients: false,
            deselectAllClients: false,
            selectAllBehaviors: false,
            deselectAllBehaviors: false,
            showBehaviorValidation: false
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this);
        this.handleBehaviorChange = this.handleBehaviorChange.bind(this);
        this.handleActiveBehaviorsChange = this.handleActiveBehaviorsChange.bind(this);
        this.handleSelectAllClients = this.handleSelectAllClients.bind(this);
        this.handleDeselectAllClients = this.handleDeselectAllClients.bind(this);
        this.handleSelectAllBehaviors = this.handleSelectAllBehaviors.bind(this);
        this.handleDeselectAllBehaviors = this.handleDeselectAllBehaviors.bind(this);
        this.handleBehaviorFieldFocus = this.handleBehaviorFieldFocus.bind(this);
        this.handleClientFieldFocus = this.handleClientFieldFocus.bind(this);
    }

    componentDidMount() {
        this.loadClients();
    }    componentDidUpdate(prevProps) {
        if (prevProps.clientsForBehaviorDownload !== this.props.clientsForBehaviorDownload && this.props.clientsForBehaviorDownload) {
            // Handle different possible data structures
            let clientsData = [];
            if (this.props.clientsForBehaviorDownload) {
                if (Array.isArray(this.props.clientsForBehaviorDownload)) {
                    clientsData = this.props.clientsForBehaviorDownload;
                } else if (this.props.clientsForBehaviorDownload.data && Array.isArray(this.props.clientsForBehaviorDownload.data)) {
                    clientsData = this.props.clientsForBehaviorDownload.data;
                } else if (this.props.clientsForBehaviorDownload.payload && Array.isArray(this.props.clientsForBehaviorDownload.payload.data)) {
                    clientsData = this.props.clientsForBehaviorDownload.payload.data;
                } else if (this.props.clientsForBehaviorDownload.payload && Array.isArray(this.props.clientsForBehaviorDownload.payload)) {
                    clientsData = this.props.clientsForBehaviorDownload.payload;
                }
            }
            
            // Transform data to expected format {id, value}
            const transformedClients = clientsData.map(client => ({
                id: client.Id || client.id,
                value: client.Name || client.name || client.value
            }));
            
            this.setState({
                clients: transformedClients
            });
        }

        if (prevProps.behaviorsByClientIds !== this.props.behaviorsByClientIds && this.props.behaviorsByClientIds) {
            // Handle different possible data structures
            let behaviorsData = [];
            if (this.props.behaviorsByClientIds) {
                if (Array.isArray(this.props.behaviorsByClientIds)) {
                    behaviorsData = this.props.behaviorsByClientIds;
                } else if (this.props.behaviorsByClientIds.data && Array.isArray(this.props.behaviorsByClientIds.data)) {
                    behaviorsData = this.props.behaviorsByClientIds.data;
                } else if (this.props.behaviorsByClientIds.payload && Array.isArray(this.props.behaviorsByClientIds.payload.data)) {
                    behaviorsData = this.props.behaviorsByClientIds.payload.data;
                } else if (this.props.behaviorsByClientIds.payload && Array.isArray(this.props.behaviorsByClientIds.payload)) {
                    behaviorsData = this.props.behaviorsByClientIds.payload;
                }
            }
            
            // Transform data to expected format {id, value}
            const transformedBehaviors = behaviorsData.map(behavior => ({
                id: behavior.Id || behavior.id,
                value: behavior.Name || behavior.name || behavior.value
            }));
            
            this.setState({
                behaviors: transformedBehaviors
            });
        }
    }

    loadClients() {
        this.props.getClientsForBehaviorDownload();
    }    loadBehaviors(clientIds) {
        console.log('loadBehaviors called with clientIds:', clientIds);
        if (clientIds && clientIds.length > 0) {
            const clientIdString = clientIds.join(',');
            console.log('Calling getBehaviorsByClientIds with:', clientIdString);
            this.props.getBehaviorsByClientIds(clientIdString);
        } else {
            console.log('No clientIds provided, clearing behaviors');
            this.setState({ behaviors: [] });
        }
    }

    handleClose() {
        this.setState({ open: false });
        this.props.closeDialog();
    }    handleClientChange(input, selectedClients) {
        console.log('handleClientChange called with:', selectedClients);
        input.onChange(selectedClients);
        this.loadBehaviors(selectedClients);
        // Clear behavior selection when clients change
        this.props.change('behaviorIds', []);
        // No validation for client selection required
    }

    handleBehaviorChange(input, selectedBehaviors, searchText, label, selectedData) {
        // The renderAutoCompleteMultipleSelection component passes additional parameters
        // We need to handle the selectedBehaviors array properly
        if (Array.isArray(selectedBehaviors)) {
            input.onChange(selectedBehaviors);
        } else {
            // Fallback to the original behavior if the format is different
            input.onChange(selectedBehaviors);
        }
    }

    handleActiveBehaviorsChange(event, isInputChecked) {
        // This will be handled by the checkbox field directly
    }    handleSelectAllClients() {
        const allClientIds = this.state.clients.map(client => client.id);
        this.props.change('clientIds', allClientIds);
        this.loadBehaviors(allClientIds);
        this.setState({ selectAllClients: true, deselectAllClients: false });
    }

    handleDeselectAllClients() {
        this.props.change('clientIds', []);
        this.props.change('behaviorIds', []);
        this.setState({ behaviors: [], selectAllClients: false, deselectAllClients: true });
    }

    handleSelectAllBehaviors() {
        const currentClients = this.props.formValues && this.props.formValues.clientIds;
        if (!currentClients || currentClients.length === 0) {
            this.setState({ showBehaviorValidation: true });
            return;
        }
        const allBehaviorIds = this.state.behaviors.map(behavior => behavior.id);
        this.props.change('behaviorIds', allBehaviorIds);
        this.setState({ selectAllBehaviors: true, deselectAllBehaviors: false });
    }

    handleDeselectAllBehaviors() {
        this.props.change('behaviorIds', []);
        this.setState({ selectAllBehaviors: false, deselectAllBehaviors: true });
    }

    handleBehaviorFieldFocus() {
        const selectedClients = this.props.formValues && this.props.formValues.clientIds ? this.props.formValues.clientIds : [];
        if (selectedClients.length === 0) {
            this.setState({ showBehaviorValidation: true });
        }
    }

    handleClientFieldFocus() {
        const selectedClients = this.props.formValues && this.props.formValues.clientIds ? this.props.formValues.clientIds : [];
        if (selectedClients.length === 0) {
            // this.setState({ showClientValidation: true }); // Removed as per edit hint
        }
    }

    handleDownload() {
        const { formValues } = this.props;
        const clientIds = formValues && formValues.clientIds ? formValues.clientIds : [];
        const behaviorIds = formValues && formValues.behaviorIds ? formValues.behaviorIds : [];
        const downloadActiveBehaviorsOnly = formValues && formValues.downloadActiveBehaviorsOnly ? formValues.downloadActiveBehaviorsOnly : false;
        // No required validation for clientIds
        const requestData = {
            clientIds: clientIds,
            behaviorIds: behaviorIds,
            downloadActiveBehaviorsOnly: downloadActiveBehaviorsOnly
        };
        
        this.props.downloadBehaviorsForRawData(requestData);
        
        // Close the modal after initiating download
        this.handleClose();
    }render() {
        const { loading, downloadBehaviorsForRawDataLoading, handleSubmit, formValues } = this.props;
        const { clients, behaviors } = this.state;
        
        const selectedClients = formValues && formValues.clientIds ? formValues.clientIds : [];
        const selectedBehaviors = formValues && formValues.behaviorIds ? formValues.behaviorIds : [];

        const actions = [
            <CommonButton className="mr-15 grey_btn" label="Cancel" onClick={this.handleClose} />,
            <CommonButton 
                label="Download Behaviors For Raw Data" 
                primary={true} 
                onClick={this.handleDownload}
                disabled={downloadBehaviorsForRawDataLoading}
            />
        ];

        return (
            <div>
                <Dialog
                    className="custom_modal"
                    title="Download Behaviors for uploading Raw Data"
                    modal={false}
                    open={this.state.open}
                    actions={actions}
                    autoScrollBodyContent={true}
                >
                    <form onSubmit={handleSubmit(this.handleDownload)}>
                        <div className="row">
                            <div className="col-sm-12">
                                <div style={{ fontStyle: 'italic', marginBottom: '15px' }}>
                                    <strong>*By default this template shows both active and inactive behaviors. Please use filters for other options.</strong>
                                </div>
                                
                                <div className="row">
                                    <div className="col-sm-6 mt-10">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="sech_item_team">
                                                    <span className={this.state.selectAllClients ? 'active' : ''} onClick={this.handleSelectAllClients}>(Select All Clients </span>
                                                    <span className={this.state.deselectAllClients ? 'active' : ''} onClick={this.handleDeselectAllClients}>Deselect All Clients ) </span>
                                                </div>
                                            </div>                                            <div className="col-sm-12">
                                                <Field
                                                    name='clientIds'
                                                    floatingLabel="Client Name"
                                                    options={clients}
                                                    handleNewRequest={this.handleClientChange}
                                                    component={renderAutoCompleteMultipleSelection}
                                                    onFocus={undefined}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-6 mt-10">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="sech_item_team">
                                                    <span className={this.state.selectAllBehaviors ? 'active' : ''} onClick={this.handleSelectAllBehaviors}>(Select All Behaviors </span>
                                                    <span className={this.state.deselectAllBehaviors ? 'active' : ''} onClick={this.handleDeselectAllBehaviors}>Deselect All Behaviors ) </span>
                                                </div>
                                            </div>                                            <div className="col-sm-12">
                                                <Field
                                                    name='behaviorIds'
                                                    floatingLabel="Behavior Name"
                                                    options={behaviors}
                                                    component={renderAutoCompleteMultipleSelection}
                                                    disabled={selectedClients.length === 0}
                                                    onFocus={this.handleBehaviorFieldFocus}
                                                />
                                                {selectedClients.length === 0 && this.state.showBehaviorValidation && (
                                                    <p style={{ color: "rgb(244, 67, 54)", fontSize: "12px", lineHeight: "12px", marginTop: "5px" }}>
                                                        Please select Client Name first.
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-20">
                                    <div className="col-sm-12">
                                        <Field
                                            name="downloadActiveBehaviorsOnly"
                                            label="Download Active Behaviors Only"
                                            component={renderCheckBox}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.downloadBehaviorsReducer.loading,
        downloadBehaviorsForRawDataLoading: state.downloadBehaviorsReducer.downloadBehaviorsForRawDataLoading,
        clientsForBehaviorDownload: state.downloadBehaviorsReducer.clientsForBehaviorDownload,
        behaviorsByClientIds: state.downloadBehaviorsReducer.behaviorsByClientIds,
        formValues: state.form.DownloadBehaviorsForRawDataForm && state.form.DownloadBehaviorsForRawDataForm.values
    };
};

const mapDispatchToProps = {
    getClientsForBehaviorDownload,
    getBehaviorsByClientIds,
    downloadBehaviorsForRawData,
    change
};

DownloadBehaviorsForRawDataModal = reduxForm({
    form: 'DownloadBehaviorsForRawDataForm',
    enableReinitialize: true,
    initialValues: {
        clientIds: [],
        behaviorIds: [],
        downloadActiveBehaviorsOnly: false
    }
})(DownloadBehaviorsForRawDataModal);

export default connect(mapStateToProps, mapDispatchToProps)(DownloadBehaviorsForRawDataModal); 


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downloadTargetsBehaviors/DownloadBehaviorsForRawDataModal.js